import React from 'react';
import CareersHero from '../components/careers/CareersHero';
import JobListings from '../components/careers/JobListings';
import CareersCTA from '../components/careers/CareersCTA';
const Careers: React.FC = () => {
  return (
    <div className="w-full">
      <CareersHero />
      <JobListings />
      <CareersCTA />
      {/* <TeamSection /> */}
    </div>
  );
};

export default Careers;
